import { NavigationService } from "@/shared/services/NavigationService";
import { SystemView } from "@/shared/constants/Views.enum";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  COLLECTIONS_NAME,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  DEPENDENCIES_ACCESS,
  DEPENDENCIES_CONSTANTS,
  EMITS,
  FILTER_SEARCH_USER_DEPENDENCIES,
  PAGINATION_USER
} from "../../constants/DependenciesConstants";
import { DependenciesService } from "../../services/DependenciesService";
import { Dependency } from "../../models/Dependency";
import { UserStatus } from "../../../User/models/UserStatus";
import { UserQuery } from "../../../User/models/UserQuery";
import { USER_STATES } from "../../../User/constants/UserConstants";
import { UserService } from "../../../User/services/UserService";
import { NAME_FINDERS, STATE } from "@/shared/constants/GeneralConstants";
import { AxiosError } from "axios";
import { QueryFilter } from "@/shared/components/GenericSearchBar/model/FilterOneItem";
import SearchOneFilter from "./../../../../shared/components/GenericSearchBar/components/SearchOneFilter/SearchOneFilter.vue";
import ImgAvatar from "./../../../../shared/components/ImgAvatar/ImgAvatar.vue";
import { Utils } from "@/shared/utils/utils";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ScrollBottom from "@/shared/components/ScrollBottom/ScrollBottom.vue";

Vue.use(Vuetify);

@Component({
  name: "SaveDependencies",
  components: {
    SearchOneFilter,
    ModalTemplate,
    EmptyState,
    ImgAvatar,
    ScrollBottom
  }
})
export default class SaveDependencies extends Vue {
  @Inject() dependenciesService!: DependenciesService;
  @Inject() userService!: UserService;

  @Prop({ default: false }) isModal!: boolean;

  USER_DEPENDENCI_KEY = NAME_FINDERS.USER_DEPENDENCI;
  SAVE_BUTTON = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL_BUTTON = FORM_CONSTANTS.BUTTON.CANCEL;
  NAME_LABEL = DEPENDENCIES_CONSTANTS.LABEL.NAME;
  STATE_LABEL = FORM_CONSTANTS.LABEL.STATE;
  SEL_USERS = DEPENDENCIES_CONSTANTS.LABEL.SEL_USERS;
  HINT_USERS = DEPENDENCIES_CONSTANTS.LABEL.HINT_USERS;
  SEARCH_USER = DEPENDENCIES_CONSTANTS.LABEL.SEARCH_USER;
  HINT_SEARCH_USER = DEPENDENCIES_CONSTANTS.LABEL.HINT_SEARCH_USER;
  LOAD_MORE_OPTIONS = DEPENDENCIES_CONSTANTS.BUTTON.LOAD_MORE_OPTIONS;
  USER_FILTERS = DEPENDENCIES_CONSTANTS.USER_FILTERS;
  ELEMENT_INACTIVE = STYLE_CLASSES.ELEMENT_INACTIVE;

  title = DEPENDENCIES_CONSTANTS.TITLE.ADD_DEPENDENCY;

  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  EMPTY_TITLE = DEPENDENCIES_CONSTANTS.LABEL.EMPTY_TITLE;
  EMPTY_TEXT_FILTER = DEPENDENCIES_CONSTANTS.LABEL.EMPTY_TEXT_FILTER;

  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];

  docRef!: string;
  isEditing = false;
  modalConfirmationText = "";
  modalConfirmationTitle = "";
  dialogConfirmation = false;
  listUsers: UserStatus[] = [];
  userFilter = 0;
  searchUser = "";

  dependencyForm = false;
  dependencyName = "";
  dependencyState = true;
  dependencyUsers: UserStatus[] = [];
  userLastRef?: string = "";
  STATE = STATE;
  dependencyExternal = false;
  itemFilter = {
    ...FILTER_SEARCH_USER_DEPENDENCIES,
    getData: this.getUserData
  };
  errorsName: string[] = [];
  isValidName = false;
  usersBox = "";
  loadingData = false;
  editComparationStr = "";
  invalidEdit = false;

  async getUserData(query: QueryFilter) {
    this.dependencyUsers = await this.getUsers(this.dependencyName, query);
  }

  async mounted() {
    if (this.$route.params.id && !this.isModal) {
      this.docRef = this.$route.params.id;
      this.isEditing = true;
      this.title = DEPENDENCIES_CONSTANTS.TITLE.EDIT_DEPENDENCY;
      await this.getDependencyData(this.docRef);
    }
  }

  @Watch("dependencyState")
  @Watch("dependencyExternal")
  checkEdit() {
    if (this.isEditing) {
      this.invalidEdit =
        JSON.stringify({
          state: this.dependencyState,
          external: this.dependencyExternal
        }) === this.editComparationStr;
    }
  }
  save() {
    this.modalConfirmationTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
    this.modalConfirmationText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    this.dialogConfirmation = true;
  }

  cancel() {
    this.modalConfirmationTitle = FORM_MESSAGES.CANCEL_MODAL.TITLE;
    this.modalConfirmationText = FORM_MESSAGES.CANCEL_MODAL.MESSAGE;
    this.dialogConfirmation = true;
  }

  async handleModalAccept() {
    this.dialogConfirmation = false;
    if (this.modalConfirmationTitle === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      if (this.isModal) {
        this.$emit(EMITS.CLOSE_MODAL);
      } else {
        this.$router.go(-1);
      }
    }
    if (this.modalConfirmationTitle === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.saveChanges();
    }
  }

  handleModalCancel() {
    this.dialogConfirmation = false;
  }

  async getDependencyData(idDependendcy: string) {
    try {
      const responseData = await this.dependenciesService.getDependency(
        idDependendcy
      );
      if (responseData.code === Http.Found && responseData.data) {
        this.dependencyName = responseData.data.name;
        this.dependencyState =
          responseData.data.state === FORM_CONSTANTS.STATE.ACTIVE
            ? true
            : false;
        this.dependencyExternal = responseData.data.external ?? false;
        this.dependencyUsers = await this.getUsers(this.dependencyName);

        this.isValidName = this.dependencyName != "" ? true : false;
        this.editComparationStr = JSON.stringify({
          state: this.dependencyState,
          external: this.dependencyExternal
        });
        this.invalidEdit = true;
      } else {
        Snackbar.popError(responseData.message);
        NavigationService.navigateTo(SystemView.DEPENDENCIES);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.GET
        );
      } else {
        Snackbar.popError(
          (error as ReferenceError).message || FORM_MESSAGES.REQUEST_FAILED
        );
      }
    }
  }

  async saveChanges() {
    const dependency: Dependency = {
      state: this.dependencyState
        ? FORM_CONSTANTS.STATE.ACTIVE
        : FORM_CONSTANTS.STATE.INACTIVE,
      name: this.dependencyName,
      users: this.dependencyUsers.map(user => user.id) || [],
      external: this.dependencyExternal
    };
    const user = localStorage.getItem(FORM_CONSTANTS.UID_TEXT) || "";

    if (this.isEditing) {
      dependency.changedBy = user;
      await this.updateDependency(dependency);
    } else {
      dependency.createdBy = user;
      await this.saveDependency(dependency);
    }
  }

  async updateDependency(dependency: Dependency) {
    try {
      const response = await this.dependenciesService.updateDependency(
        this.docRef,
        dependency
      );

      if (response.code === Http.Ok) {
        Snackbar.popSuccess(response.message);
        NavigationService.navigateTo(SystemView.DEPENDENCIES);
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async saveDependency(dependency: Dependency) {
    try {
      const response = await this.dependenciesService.createDependency(
        dependency
      );

      if (response.code === Http.Ok) {
        Snackbar.popSuccess(response.message);
        if (this.isModal) {
          const createNameDep = true;
          this.$emit(EMITS.SAVE_MODAL, dependency.name, createNameDep);
        } else {
          NavigationService.navigateTo(SystemView.DEPENDENCIES);
        }
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.POST
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  addUserSelected(user: UserStatus) {
    const find = this.dependencyUsers.find(u => u.id == user.id);
    if (!find) this.dependencyUsers?.push(user);
  }

  async getUsers(dependencyName: string, userQueryFilters?: UserQuery) {
    const query: UserQuery = {
      dependency: [dependencyName],
      state: USER_STATES.ACTIVE,
      paginationAmount: PAGINATION_USER
    };

    if (userQueryFilters && userQueryFilters.name) {
      this.dependencyUsers = [];
      query.name = [userQueryFilters.name as string];
    }

    if (userQueryFilters && userQueryFilters.userDocument) {
      this.dependencyUsers = [];
      query.userDocument = [userQueryFilters.userDocument as string];
    }

    if (userQueryFilters && userQueryFilters.userEmail) {
      this.dependencyUsers = [];
      query.userEmail = [userQueryFilters.userEmail as string];
    }

    try {
      this.loadingData = true;
      const responseData = await this.userService.getUsersByFiltersArrayUsersCrud(
        query
      );

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.loadingData = false;
        return responseData.data.userArray;
      } else {
        this.loadingData = false;
        return [];
      }
    } catch (error) {
      this.loadingData = false;
      if (
        error instanceof ReferenceError ||
        (error as AxiosError).response?.status == Http.Forbidden
      )
        throw error;
      throw Error(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.DEPENDENCY,
      this.dependencyName
    );
    this.isValidName = !(this.errorsName.length > 0);
  }

  async onBottomScroll(e: any) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if (scrollTop + offsetHeight >= scrollHeight - 1) {
      const users = await this.getUsers(this.dependencyName);
      this.dependencyUsers = [...this.dependencyUsers, ...users];
    }
  }

  goToPatientProfile(item: UserStatus) {
    NavigationService.navigateTo(SystemView.PROFILE, { id: item.id });
  }
}
